import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import mq from '../../../styles/breakpoints';
import Colors from '../../../styles/colors';
import { Body } from '../../../styles/generic';

import CloseIcon from '../icons/CloseIcon';

interface Props {
  children: ReactNode;
  customClick: () => void;
  windowDirection?: string;
}

const TooltipWindow = ({
  children,
  customClick,
  windowDirection = 'left',
}: Props) => (
  <Wrapper windowDirection={windowDirection}>
    <Container>
      <TextWrapper>{children}</TextWrapper>
      <Triangle position={windowDirection} />
      <CancelButton
        data-testid="close-button"
        aria-label="Sluit Info Popover"
        onClick={() => {
          customClick();
        }}
      >
        <CloseIcon
          ariaHidden
          color={Colors.abnGreen300}
          width="14"
          height="14"
        />
      </CancelButton>
    </Container>
  </Wrapper>
);

export default TooltipWindow;

const Container = styled.div`
  height: fit-content;
  position: relative;
`;

const Wrapper = styled.div<{ windowDirection?: string }>`
  bottom: 32px;
  min-width: 320px;
  position: absolute;
  right: -20px;

  ${mq.from.breakpoint.M`
    ${({ windowDirection }: { windowDirection?: string }) =>
      windowDirection === 'left'
        ? css`
            right: -20px;
          `
        : css`
            left: -20px;
          `}
  `}
`;

const TextWrapper = styled(Body)`
  background: ${Colors.white};
  border-radius: ${({ theme }) => theme.radiuses.M};
  box-shadow: ${({ theme }) => theme.elevations.abnPopover};
  color: ${Colors.abnBlack};
  padding: 16px 32px 16px 16px;

  & > h4 {
    margin-bottom: 8px;
    margin-top: 0;
  }

  & > p {
    margin-top: 0;
  }

  & > p:first-of-type {
    margin-top: 0;
  }

  & > p:last-of-type {
    margin-bottom: 0;
  }
`;

const CancelButton = styled.a`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 48px;
  justify-content: center;
  line-height: 0;
  position: absolute;
  right: 0;
  text-decoration: none;
  top: 0;
  width: 48px;

  &:hover {
    cursor: pointer;
  }
`;

const Triangle = styled.div<{ position?: string }>`
  bottom: -10px;
  height: 40px;
  margin: 10px;
  overflow: hidden;
  position: absolute;
  right: 0;
  transform: rotate(225deg);
  width: 40px;

  &:after {
    background-color: ${Colors.white};
    content: '';
    height: 142%;
    position: absolute;
    transform: rotate(45deg) translate(-71%, 0);
    width: 142%;
  }

  ${mq.from.breakpoint.M`
    ${({ position }: { position?: string }) =>
      position === 'left'
        ? css`
            right: 0;
          `
        : css`
            left: 0;
          `}
  `}
`;
